import config from 'config';
import axios from 'axios';

import DashboardService from './dashboard_service';
import UsersService from './users_service';
import OperationsService from './operations_service';
import RolesService from './roles_service';
import GroupsService from './groups_service';
import ThresholdsService from './thresholds_service';
import AlertsService from './alerts_service';
import GroupingsService from './groupings_service';
import DevicesService from './devices_service';
import AssetsService from './assets_service';
import AssetTypesService from './asset_types_service';
import DevicesRegistrationService from './device_registration_service';
import DeviceTypesService from './device_types_service';
import AuthenticationService from './authentication_service';
import EventConfigurationsService from "./event_configurations_service";
import ActionsService from './actions_service';
import TicketsService from './tickets_service';
import ActionResultTypesService from './action_result_types_service';
import ThresholdEvaluationTypesService from './threshold_evaluation_types_service';
import DeviceDataTypesService from './device_data_types_service';
import AlertLevelsService from './alert_levels_service';
import DeviceStatusesService from './device_statuses_service';
import ThresholdClassificationsService from './threshold_classifications_service';
import TimeFormattingService from './time_formatting_service';
import AlertStatusesService from './alert_statuses_service';
import TagsService from './tags_service';
import ChecklistConfigsService from './checklist_configs_service';
import CompletedChecklistService from './completed_checklist_service';
import RoutesService from './routes_services';
import EventConfigurationStatusesService from "./event_configuration_status_service";
import VersionService from './version_service';
import ForgotPasswordService from './forgotpassword_service';
import ContentService from './content_service';
import PastChecklistsService from './past_checklists_service';
import ChecklistUserService from './checklist_user_service';
import ReportConfigsService from './report_configs_service';
import SchedulerService from './scheduler_service';
import HologramService from './hologram_service';
import LocalesService from './locales_service';
import DocumentsService from './documents_service';
import ActionRoleTemplatesService from './action_role_templates_service';
import SetupService from './setup_service';
import SSOMappingsService from './sso_mappings_service';
import AuditService from './audit_service';
import DeviceDataClassificationsService from './device_data_classifications_service';
import BLEService from './ble_service';
import DeviceInventoryService from './device_inventory_service';
import EntityService from './entity_service';
import DeviceDataOverrideService from './device_data_override_service';
import UserUnitService from './user_unit_service';
import ChecklistReportService from './checklist_report_service';
import APIConfigurationService from './api_configuration_service';

axios.interceptors.request.use((config) => {
  if (localStorage.getItem("token")) {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
  }
  if (config.metadata) {
    config.metadata['startTime'] = new Date();
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status == 401) {
    localStorage.removeItem('token');
    localStorage.setItem('auth-error', 'Your session has expired.');
    setTimeout(() => {
      window.location.href = `${window.location.protocol}//${window.location.hostname}:${window.location.port}${config.WEB_SUB_URL}`;
    }, 250);
  }

  if (error.response && error.response && error.response.data  && error.response.data.genericSystemErrorMessage) {
    console.error(error.response.data.genericSystemErrorMessage);
  } else if (error.response && error.response && error.response.data && error.response.data.errorMessage) {
    console.error(error.response.data.errorMessage);
  } else {
    console.error(error);
  }

  return Promise.reject(error);
});

export {
    DashboardService,
    UsersService,
    RolesService,
    GroupsService,
    GroupingsService,
    DevicesService,
    AssetsService,
    AssetTypesService,
    DevicesRegistrationService,
    ThresholdsService,
    AlertsService,
    OperationsService,
    AuthenticationService,
    EventConfigurationsService,
    ActionsService,
    TicketsService,
    ActionResultTypesService,
    ThresholdEvaluationTypesService,
    DeviceDataTypesService,
    AlertLevelsService,
    DeviceStatusesService,
    DeviceTypesService,
    EntityService,
    ThresholdClassificationsService,
    TimeFormattingService,
    AlertStatusesService,
    TagsService,
    ChecklistConfigsService,
    CompletedChecklistService,
    RoutesService,
    EventConfigurationStatusesService,
    VersionService,
    ForgotPasswordService,
    ContentService,
    PastChecklistsService,
    ChecklistUserService,
    ReportConfigsService,
    SchedulerService,
    HologramService,
    LocalesService,
    DocumentsService,
    ActionRoleTemplatesService,
    SetupService,
    SSOMappingsService,
    AuditService,
    DeviceDataClassificationsService,
    BLEService,
    DeviceInventoryService,
    DeviceDataOverrideService,
    UserUnitService,
    ChecklistReportService,
    APIConfigurationService,
};
